import React from 'react';
import propTypes from 'prop-types';

const RadioButton = ({ id, label, ...htmlProps }) => (
  <div className="cmp-radio-button">
    <input
      id={id}
      type="radio"
      className="cmp-radio-button__input"
      {...htmlProps}
    />
    <label
      htmlFor={id}
      className="cmp-radio-button__label"
    >
      {label}
    </label>
  </div>
);

RadioButton.propTypes = {
  id: propTypes.string,
  label: propTypes.string,
};

export { RadioButton };
